import { SelectField } from '@today/ui-components'
import { Button } from '@today/ui-primitives'
import type { ReactElement } from 'react'
import type { ErasureFormValues, FormState, Option, Translate } from './compliance-types'
import { FormAlert, TextInput } from './form-parts'

/**
 * Props for {@link ErasureRequestFormView}: the form state plus the basis choices.
 * Rendered only for a viewer holding `compliance.erasure.manage`.
 */
export interface ErasureRequestFormViewProps extends FormState<ErasureFormValues> {
	t: Translate
	basisOptions: Option[]
}

/** The "New erasure request" form: customer id, basis, grace days and note (organism). */
export function ErasureRequestFormView(props: ErasureRequestFormViewProps): ReactElement {
	const { t, values, errors, onChange } = props
	const title = t('erasureForm.title')
	return (
		<form
			aria-label={title}
			className="flex flex-col gap-3"
			onSubmit={(event) => {
				event.preventDefault()
				props.onSubmit()
			}}
		>
			<h2 className="text-ds-lg font-semibold text-ds-text">{title}</h2>
			<TextInput
				label={t('erasureForm.customerId')}
				value={values.customerId}
				error={errors.customerId}
				onChange={(v) => onChange('customerId', v)}
			/>
			<SelectField
				label={t('erasureForm.basis')}
				value={values.basis}
				error={errors.basis}
				onValueChange={(v) => onChange('basis', v)}
				options={props.basisOptions.map((o) => ({ id: o.id, text: o.label }))}
			/>
			<TextInput
				label={t('erasureForm.graceDays')}
				type="number"
				value={values.graceDays}
				error={errors.graceDays}
				onChange={(v) => onChange('graceDays', v)}
			/>
			<TextInput
				label={t('erasureForm.note')}
				value={values.note}
				error={errors.note}
				onChange={(v) => onChange('note', v)}
			/>
			<FormAlert message={props.message} />
			<Button type="submit" isDisabled={props.submitting}>
				{t('erasureForm.submit')}
			</Button>
		</form>
	)
}
